import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { HomeComponent } from './core/components/home/home.component';
import { SettingsComponent } from './core/components/settings/settings.component';
import { LoginComponent } from './core/components/login/login.component';

import { UserResolver } from '@core/resolvers/user.resolver';
import { ConfigResolver } from '@core/resolvers/config.resolver';

const routes: Routes = [
	{
		path: '',
		canActivate: [OktaAuthGuard],
		resolve: {
			user: UserResolver,
			config: ConfigResolver
		},
		children: [
			{
				path: '',
				component: HomeComponent
			},
			{
				path: 'settings',
				component: SettingsComponent
			},
			{
				path: 'collect',
				loadChildren: () => import('./modules/collect/collect.module').then(m => m.CollectModule)
			},
			{
				path: 'inspection',
				loadChildren: () => import('./modules/inspection/inspection.module').then(m => m.InspectionModule)
			},
			{
				path: 'dossier',
				loadChildren: () => import('./modules/dossier/dossier.module').then(m => m.DossierModule)
			},
			{
				path: 'portomechanic',
				loadChildren: () => import('./modules/portomechanic/portomechanic.module').then(m => m.PortomechanicModule)
			}
		]
	},
	{ path: 'login', component: LoginComponent },
	{ path: 'implicit/callback', component: OktaCallbackComponent },
	{ path: '**', redirectTo: '/' }
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: false, relativeLinkResolution: 'legacy', onSameUrlNavigation: 'reload' })],
	exports: [RouterModule],
	providers: [ConfigResolver, UserResolver]
})
export class AppRoutingModule { }